export default __webpack_public_path__ + "static/media/modal_overlay.4e7ba835.png";